function Queue(){
    this.items = [];
    //向队列添加元素
    this.enqueue = function(element){
        this.items.push(element);
    }
    this.dequeue = function(){
        return this.items.shift();
    }
    this.isEmpty = function(){
        return this.items.length === 0;
    }
    this.front = function(){
        return this.items[0];
    }
    this.size = function(){
        return this.items.length;
    }
    this.clear = function(){
        this.items = [];
    }
    this.print = function(){
        console.log("队列元素:",this.items.toString() + "--队列元素数量",this.items.length);
    }
}

export default Queue;
